import { render, staticRenderFns } from "./StudiengangUpload.vue?vue&type=template&id=59255a45"
import script from "./StudiengangUpload.vue?vue&type=script&lang=js"
export * from "./StudiengangUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports